<script>
    import Button from "$lib/atoms/Button.svelte";
    import { ArrowRight } from "lucide-svelte";
    import '../../app.css';
    import { t } from '$lib/i18n.js';
    import { page } from '$app/stores';

    $: lang = $page.params.lang || 'en';
</script>

<section>
    <img src="https://assets.auting.it/images/blobs/owner.svg" alt="Background Blob" class="blob" />
    <div class="col">
        <h3>{$t('components.owner.top_subheadline')}</h3>
        <h2>{$t('components.owner.headline')}</h2>
        <Button
            icon={ArrowRight}
            label="{$t('components.owner.cta')}"
            textColor="var(--on-primary)"
            backgroundColor="var(--orange)"
            href="/{lang}/owner"
        />
    </div>
    <div class="col">
        <img src="https://assets.auting.it/images/draws/owner.svg" alt={$t('components.owner.img_alt')} />
    </div>
</section>

<style>
    .blob {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: -1;
        padding: 2rem;
        max-width: var(--max-width);
        object-fit: contain;
        object-position: center;
    }

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding-top: 100px;
        padding-bottom: 100px;
        gap: 16px;
    }

    .col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 16px;
        max-width: var(--max-width);
        width: 100%;
        margin: 0 auto;
		padding: 1rem 2rem;
        flex: 1;
    }

    h3 {
        font-family: var(--font-body);
        color: var(--on-surface);
        margin:0;
        padding:0;
    }

    h2 {
        text-align: center;
    }

    .col img {
        width: 100%;
        height: 500px;
        object-fit: contain;
        object-position: left;
    }

    @media (max-width: 768px) {
        section {
            flex-direction: column;
            align-items: stretch;
            padding: 1rem;
            padding-top: 100px;
            position: relative;
        }

        .blob {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: auto;
            z-index: -1;
            object-position: bottom;
        }

        .col img {
        width: 100%;
        height: 200px;
        object-fit: contain;
        object-position: left;
    }
    }
</style>
